'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _colors = require('../styles/colors');

var _styles = require('./styles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Checkbox = function (_PureComponent) {
  _inherits(Checkbox, _PureComponent);

  function Checkbox(props) {
    _classCallCheck(this, Checkbox);

    var _this = _possibleConstructorReturn(this, (Checkbox.__proto__ || Object.getPrototypeOf(Checkbox)).call(this, props));

    _this.onClick = _this.onClick.bind(_this);

    _this.state = { value: props.value || false };
    return _this;
  }

  _createClass(Checkbox, [{
    key: 'onClick',
    value: function onClick() {
      if (this.props.value != null) {
        return;
      }
      if (this.props.onClick) {
        this.props.onClick(!this.state.value);
      }
      this.setState({ value: !this.state.value });
    }
  }, {
    key: 'getLabel',
    value: function getLabel() {
      if (this.props.label) {
        return this.props.label;
      }
      if (this.props.name) {
        return _react2.default.createElement(
          'label',
          { htmlFor: this.props.id },
          this.props.name
        );
      }
      return '';
    }
  }, {
    key: 'getValue',
    value: function getValue() {
      if (this.props.value != null) {
        return this.props.value;
      }
      return this.state.value;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var classes = (0, _classnames2.default)(_styles.checkbox.toString(), this.props.className);
      var subClasses = (0, _classnames2.default)(_styles.check.toString(), _defineProperty({}, _styles.selected.toString(), this.getValue()), this.props.checkClass);
      return _react2.default.createElement(
        'button',
        {
          id: this.props.id,
          className: classes,
          value: this.getValue(),
          onClick: function onClick() {
            return _this2.onClick();
          }
        },
        _react2.default.createElement(
          'div',
          { className: subClasses },
          this.getValue() ? _react2.default.createElement(_Icon2.default, { type: 'selected-tick', color: _colors.COLORS.WHITE }) : null
        ),
        this.getLabel()
      );
    }
  }]);

  return Checkbox;
}(_react.PureComponent);

exports.default = Checkbox;


Checkbox.propTypes = {
  id: _react.PropTypes.string.isRequired,
  onClick: _react.PropTypes.func,
  className: _react.PropTypes.string,
  checkClass: _react.PropTypes.string,
  name: _react.PropTypes.string,
  value: _react.PropTypes.bool,
  label: _react.PropTypes.node
};

Checkbox.defaultProps = {
  onClick: function onClick() {},
  className: null,
  checkClass: null,
  name: null,
  value: null,
  label: null
};


//////////////////
// WEBPACK FOOTER
// ./~/tanda-components/Checkbox/index.js
// module id = 1578
// module chunks = 0